export default "__VITE_ASSET__DWslaUm1__"